import { useMemo } from 'react';
import { useRouter } from 'next/router';

const useCanonicalUrl = (canonicalLink?: string) => {
  const router = useRouter();

  const canonicalUrl = useMemo(() => {
    if (!canonicalLink) {
      return { url: canonicalBaseUrl(router.asPath), pathParam: [] };
    }
    const { params: pathParam = [] } = router.query;
    let link = canonicalLink;

    if (pathParam.length >= 1) {
      link += `/${pathParam[0]}`;
      if (pathParam.length >= 2) {
        link += `/${pathParam[1]}`;
      }
    }

    return { url: link, pathParam };
  }, [router.query, canonicalLink, router.asPath]);

  return canonicalUrl;
};

const canonicalBaseUrl = (asPath: string) => {
  return `${process.env.NEXT_PUBLIC_BASE_URL}${asPath.split('?')[0]}`;
};

export default useCanonicalUrl;
